export const debounce = <F extends (...params: any[]) => void>(fn: F, delay: number) => {
  let timeoutID: number | null = null;
  return function (this: any, ...args: any[]) {
    timeoutID && clearTimeout(timeoutID);
    timeoutID = window.setTimeout(() => fn.apply(this, args), delay);
  } as F;
};
